/**
 * Shared date/time formatting utilities used across chat, notification, and
 * label components.
 */

/**
 * Formats an ISO 8601 timestamp string for display in chat and notification
 * contexts. Returns just the time for today's messages, or "Month D, time"
 * for older ones.
 */
export function formatChatTimestamp(iso: string): string {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const time = d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  if (d.toDateString() === new Date().toDateString()) return time;
  return `${d.toLocaleDateString([], { month: "short", day: "numeric" })}, ${time}`;
}

/**
 * Formats an HH:MM 24-hour time string into a 12-hour display string,
 * e.g. "14:30" => "2:30pm", "09:00" => "9am".
 */
export function formatHHMM(time: string): string {
  const [h, m] = time.split(":").map(Number);
  const period = h >= 12 ? "pm" : "am";
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return m === 0 ? `${hour12}${period}` : `${hour12}:${m.toString().padStart(2, "0")}${period}`;
}
